export const tenantId = 'd0772378-7c87-44f1-aa2a-0cc1c045a821';

export const defineUrl  = () => {
   return window.location.hostname === 'localhost' ? 'https://spacehamster.ch/graphql' : '/graphql'
}

